module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



//////////////////
// WEBPACK FOOTER
// ../js/~/core-js/library/modules/_is-object.js
// module id = 35
// module chunks = 0